import { DocumentService } from './document.service';
import { Observable } from 'rxjs';
import {
  DocumentAdded,
  DocumentRemoved,
  DocumentModified,
} from './document.actions';
import { ShowErrorMessage } from '../notification/notification.actions';
import { Injectable } from '@angular/core';
import { DocumentServiceSwitcherService } from './document-service-switcher.service';
import {
  WithoutMeta,
  DxDocument
} from '@digitaix/types';

@Injectable()
export class WrapperDocumentService<
  D extends DxDocument,
  Query
> extends DocumentService<D, Query> {
  constructor(public dss: DocumentServiceSwitcherService) {
    super();
  }

  public create(
    collectionPath: string,
    document: WithoutMeta<D>,
    documentId?: string,
  ): Observable<D> {
    return this.dss.usedService.create(collectionPath, document, documentId);
  }

  public delete(
    collectionPath: string,
    documentId: string,
  ): Observable<boolean> {
    return this.dss.usedService.delete(collectionPath, documentId);
  }

  public get(collectionPath: string, documentId: string): Observable<D | null> {
    return this.dss.usedService.get(collectionPath, documentId);
  }

  public getMany(
    collectionPath: string,
    documentIds: string[],
  ): Observable<D[]> {
    return this.dss.usedService.getMany(collectionPath, documentIds);
  }

  public load(collectionPath: string, query?: Query): Observable<D[]> {
    return this.dss.usedService.load(collectionPath, query);
  }

  public reset(removeLoadedDocuments: boolean = true): void {
    return this.dss.usedService.reset(removeLoadedDocuments);
  }

  public subscribe(
    collectionPath: string,
    query?: Query,
  ): Observable<
    DocumentAdded<D> | DocumentRemoved | DocumentModified<D> | ShowErrorMessage
  > {
    return this.dss.usedService.subscribe(collectionPath, query);
  }

  public update(
    collectionPath: string,
    documentId: string,
    document: Partial<WithoutMeta<D>>,
  ): Observable<D> {
    return this.dss.usedService.update(collectionPath, documentId, document);
  }
}
